// En iPhone, Safari hace zoom al enfocar un campo con letra menor a 16 px, y no lo deshace al
// salir: la pantalla quedaba agrandada y el botón de enviar fuera de la vista. En pantallas
// táctiles los campos del inbox van en 16 px; en el computador siguen como estaban.
// Va en cada contenedor y no solo en la página: el detalle (Drawer) y los diálogos se
// dibujan fuera de ella.
export const SIN_ZOOM_IPHONE = {
    "@media (pointer: coarse)": {
        "& input, & textarea": { fontSize: "16px !important" },
    },
};
